import {UserTypes} from '../globals/Constants';

interface UserModel {
   avatarUrl: string;
   name: string;
   userId: string;
   email?: string;
   isDeleted: boolean;
   userType: UserTypes;
}

export interface UserInfo {
   techSmithId: string;
   avatarUrl: string;
   displayName: string;
}

export const nullUserFactory = (initialData?: Partial<UserModel>): UserModel => (Object.assign({
   avatarUrl: '',
   name: '',
   userId: '',
   email: '',
   isDeleted: false,
   userType: UserTypes.techSmith
}, initialData));

export default UserModel;
